import React, {Fragment, useEffect, useRef, useState} from "react";
import {useInterSectionObserver} from "hooks";
import AssetListLayout from "../AssetListLayout";
import AssetItem from "../AssetItem";
import styles from "./index.module.scss";
import useDragToScrollAssetList from "../hooks/useDragToScrollAssetList";
import ScrollIndicator from "../ScrollIndicator";
function ImageTypeList({title, type, assetSearchParams, listType, data, fetchNextPage, hasNextPage}) {
  const [, loadingRef] = useInterSectionObserver(fetchNextPage, {});
  const scrollRef = useRef();
  useDragToScrollAssetList(scrollRef);
  const onClickIndicator = direction => {
    const moveTo =
      direction === "left"
        ? (parseInt(scrollRef.current.scrollLeft / 66) - 3) * 66
        : (parseInt(scrollRef.current.scrollLeft / 66) + 3) * 66;
    scrollRef.current.scrollTo({top: 0, left: moveTo, behavior: "smooth"});
  };
  const [firstEnter, setFirstEnter] = useState(true);
  const [leftEnd, setLeftEnd] = useState(true);
  const [rightEnd, setRightEnd] = useState(false);
  const [startTarget, setStartTarget] = useState(null);
  const [endTarget, setEndTarget] = useState(null);

  useEffect(() => {
    const intersectFunc = ([entry]) => {
      if (entry.target.id === "left" && entry.isIntersecting) {
        setLeftEnd(true);
        firstEnter && setFirstEnter(false);
      } else {
        if (!firstEnter) setLeftEnd(false);
      }
      entry.target.id === "right" && (entry.isIntersecting ? setRightEnd(true) : setRightEnd(false));
    };
    const observer = new IntersectionObserver(intersectFunc, {threshold: 0});
    if (startTarget) {
      observer.observe(startTarget);
      observer.observe(endTarget);
    }
    return () => {
      observer.disconnect();
    };
  }, [startTarget, endTarget, firstEnter]);
  return (
    <AssetListLayout title={title} type={type} assetSearchParams={assetSearchParams}>
      <div className={styles.list_container}>
        <ul className={styles.list} ref={scrollRef}>
          {!leftEnd && <ScrollIndicator position={"left"} onClick={() => onClickIndicator("left")} />}
          <div id="left" ref={setStartTarget}></div>
          {data?.pages?.map((page, pageIdx) => (
            <Fragment key={pageIdx}>
              {page?.map(asset => (
                <div className={styles.asset_wrapper} key={asset.id}>
                  <AssetItem data={asset} appearance={{listType}} />
                </div>
              ))}
            </Fragment>
          ))}
          {hasNextPage && <div className={styles.asset} ref={loadingRef}></div>}
          <div id="right" ref={setEndTarget}></div>
          {!rightEnd && <ScrollIndicator position={"right"} onClick={() => onClickIndicator("right")} />}
        </ul>
      </div>
    </AssetListLayout>
  );
}

export default ImageTypeList;
